<svelte:options accessors/>
<script>
    import {createEventDispatcher} from "svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import NauiTextarea from "../../../naui/atoms/NauiTextarea.svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";

    const events = new createEventDispatcher();

    export let data;

    function agregarMueble() {
        data.muebles.push({
            descripcion: '',
            observaciones: ''
        });
        data = data;
    }

    function eliminarMueble(index) {
        data.muebles.splice(index, 1);
        data = data;
    }

    function cambioCheckboxDeposito() {
        if (data.tiene_deposito) {
            data.contenido_deposito = ''
        }
    }
</script>
<div>
    <fieldset>
        <legend>MUEBLES ESPECIALES</legend>
        {#each data.muebles as mueble, i}
            <div class="box-3">
                <NauiButton on:click={eliminarMueble.bind(this, i)}
                            icon="times"
                            mode="stroked"
                            color="accent"/>
            </div>
            <div class="grid-2 gap-15">
                <NauiInput label="Descripción" bind:value={mueble.descripcion}/>
                <NauiTextarea label="Observaciones" bind:value={mueble.observaciones}/>
            </div>
        {/each}
        <div class="box-l">
            <NauiButton on:click={agregarMueble}
                        caption="AGREGAR MUEBLE"
                        icon="plus"
                        mode="solid"
                        color="accent"
                        className="mr-2"/>

            <NauiButton on:click={() => {events('verImagenes')}}
                        caption="VER IMAGENES DEL SERVICIO"
                        icon="images"
                        mode="solid"
                        color="accent"/>
        </div>

        <div class="grid-3 gap-15 mt-2">
            <NauiCheckbox label="¿Tiene depósito?"
                          on:input={cambioCheckboxDeposito}
                          bind:value={data.tiene_deposito}/>

            <NauiInput label="¿Qué contiene?"
                       isDisabled={!data.tiene_deposito}
                       bind:value={data.contenido_deposito}/>

            <NauiButton on:click={() => {events('verImagenes')}}
                        caption="VER IMAGENES DEL DEPÓSITO"
                        icon="images"
                        mode="solid"
                        color="accent"/>
        </div>
    </fieldset>
</div>